<template>
    <div class="w-full h-full">
        <div v-if="canAddorEditWorkflows" class="flex w-full justify-end"><base-button-affirmative @click="openAddTaskForm"><div class="text-base">Add tasks</div></base-button-affirmative></div>
        <div class="flex flex-col w-full px-4">
            <div class="w-full border-b p-1 mb-2">
                Tasks
            </div>
            <ClientWorkflowStep :can-add-or-edit="canAddorEditWorkflows" :is-loading="isLoading" @delete-workflow-step=deleteStep @edit-workflow-step="editClientWorkflowStep" v-for="step in openWorkflowSteps" :key="step.id" :client-workflow-step="step" :client="client" />
        </div>
        <div class="flex flex-col w-full px-4">
            <div class="w-full border-b p-1 mb-2">
                Completed
            </div>
            <ClientWorkflowStep :can-add-or-edit="canAddorEditWorkflows" :is-loading="isLoading" @delete-workflow-step=deleteStep @edit-workflow-step="editClientWorkflowStep"  v-for="step in completedWorkflowSteps" :key="step.id" :client-workflow-step="step" :client="client" />
        </div>
        <base-modal-small 
                v-if="showAddTaskForm"
                @close="closeAddTaskForm">
              <template v-slot:header>
                Add Tasks
              </template>
              <template v-slot:body>
                <AddClientWorkflowStepForm @add-workflow-steps="addMultipleClientWorkflowSteps" :workflow-steps="workflowSteps" :client="client" />
              </template>
        </base-modal-small>
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits, computed } from 'vue';
import { getWorkflowSteps } from '@/services/Workflow';
import { useStore } from 'vuex';
import ClientWorkflowStep from './workflow_components/ClientWorkflowStep.vue';
import { createClientWorkflowStep, createMultipleClientWorkflowSteps, updateClientWorkflowStep, deleteClientWorkflowStep } from '@/services/ClientWorkflowStep';
import { useToast } from 'vue-toast-notification';
import AddClientWorkflowStepForm from './workflow_components/AddClientWorkflowStepForm.vue';

const store = useStore()
const props = defineProps([
    'client', 'isLoading', "workflowSteps"
])
const $toast = useToast()

const emit = defineEmits(['refetch-clients'])

const isLoading = ref(false)

async function deleteStep(stepId) {
    isLoading.value = true
    const token = store.state.auth.token
    const result = await deleteClientWorkflowStep(token, stepId)
    if(result.status == 204){
        emit('refetch-clients')
        isLoading.value = false
    }
}

const completedWorkflowSteps = computed(() => {
    return props.client.workflow_steps.filter((step) => {
        return step.completed_on
    })
})
// const completedWorkflowSteps = computed(() => {
//     return workflowSteps.value.filter((workflowStep) => {
//         return props.client.workflow_steps.map((step) => step.workflow_step.id).includes(workflowStep.id)
//     })
// })

const openWorkflowSteps = computed(() => {
    return props.client.workflow_steps.filter((step) => {
        return !step.completed_on
    })
})
// const openWorkflowSteps = computed(() => {
//     return workflowSteps.value.filter((workflowStep) => {
//         return !completedWorkflowSteps.value.map((step) => step.id).includes(workflowStep.id)
//     })
// })

const showAddTaskForm = ref(false)

function openAddTaskForm(){
    showAddTaskForm.value = true
}

function closeAddTaskForm(){
    showAddTaskForm.value = false
}

const canAddorEditWorkflows = computed(() => {
    let userPermissionsStore = store.getters['auth/showUserPermissions']
    return userPermissionsStore.isEditClientWorkflow || userPermissionsStore.isDev
})

// async function addClientWorkflowStep(clientWorkflowStepData){
//     const token = store.state.auth.token 
//     const result = await createClientWorkflowStep(token, clientWorkflowStepData)
//     if(result.status === 201){
//         $toast.open({
//             message: 'Successfully added Client Workflow Step',
//             type: 'success',
//             duration: 3000
//         })
//         emit('refetch-clients')
//     } else {
//         $toast.open({
//             message: 'Error, could not add Client Workflow Step',
//             type: 'error',
//             duration: 3000
//         })
//     }
// }

async function addMultipleClientWorkflowSteps(clientWorkflowStepData){
    const token = store.state.auth.token 
    const result = await createMultipleClientWorkflowSteps(token, clientWorkflowStepData)
    if(result.status === 201){
        $toast.open({
            message: 'Successfully added Client Workflow Steps',
            type: 'success',
            duration: 3000
        })
        closeAddTaskForm()
        emit('refetch-clients')
    } else {
        $toast.open({
            message: 'Error, could not add Client Workflow Steps',
            type: 'error',
            duration: 3000
        })
    }
}

async function editClientWorkflowStep(clientWorkflowStepData, clientWorkflowStepId){
    const token = store.state.auth.token 
    console.log('editing now', clientWorkflowStepData)
    const result = await updateClientWorkflowStep(token, clientWorkflowStepData, clientWorkflowStepId)
    if(result.status === 200){
        $toast.open({
            message: 'Successfully edited Client Workflow Step',
            type: 'success',
            duration: 3000
        })
        emit('refetch-clients')
    } else {
        $toast.open({
            message: 'Error, could not edit Client Workflow Step',
            type: 'error',
            duration: 3000
        })
    }
}

// console.log('client', props.client)

</script>